// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"311":"7aa51463","429":"8b5676e3","681":"faac41d4","842":"f985c435","941":"91118672"}[chunkId] + ".css";
};